// ****************************************************************************************************************************************************
// Customizes Feature Lineup

export function modifyFeatureLineup() {
  $('.featureLineupContainer').each((i, element) => {
    const $element = $(element);
    const $imageContainer = $element.find('.featureLineupImage');
    const $title = $element.find('.featureLineup-title');
    const $description = $element.find('.featureLineup-text').last();
    const $moreBtn = $element.find('.featureLineup-more');

    const titleText = $title.text().trim();
    const descriptionText = $description.text().trim();

    const contentWrapper = createContentWrapper(titleText, descriptionText);
    const wrapperAux = `<span class="featureLineup-text">${contentWrapper}</span>`;

    $title.remove();

    if ($description.length) {
      $description.html(contentWrapper);
      $description.append($moreBtn);
    } else {
      $imageContainer.append(wrapperAux);
      $imageContainer.find('.featureLineup-text').append($moreBtn);
    }
  });
}

function createContentWrapper(titleText, descriptionText) {
  return `
      <h4 title="${titleText}" aria-label="${titleText}">${titleText}</h4>
      ${descriptionText ? `<span class="feature-description">${descriptionText}</span>` : ''}
    `;
}
